import {getModel} from '../../../models/hit/modelRegistry';
import {BaseAttribute, BaseAttributeOptions} from './BaseAttribute';

/** Joined `Language` FK attribute */
export class LanguageAttribute extends BaseAttribute {
  constructor(options: BaseAttributeOptions = {}) {
    super(options);
  }

  /**
   * Converts the value from the UI input to the value type that is sent to the database
   * Returns two values:
   * - The value sent to the database
   * - The value to update the data in the UI
   */
  toDbValue(value: unknown): [unknown, unknown] {
    if (!value) return [null, null];
    const locale = value as {id: string};
    return [locale.id, value];
  }

  /** Converts the value from the database to a value that can be used in the UI */
  toLocalValue(item: Record<string, unknown>): unknown {
    let value = item[this.name];
    if (!value) return null;
    if (this.transform) {
      value = this.transform(value);
    }
    const Language = getModel('Language');
    return new Language(value);
  }
}
